'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _ThumbsUpSvg = require('./ThumbsUpSvg');

var _ThumbsUpSvg2 = _interopRequireDefault(_ThumbsUpSvg);

var _ThumbsDownSvg = require('./ThumbsDownSvg');

var _ThumbsDownSvg2 = _interopRequireDefault(_ThumbsDownSvg);

var _Input = require('../../styles/Input');

var _Input2 = _interopRequireDefault(_Input);

var _AIAnswer = require('../../styles/AIAnswer');

var _Button = require('../../styles/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AIFeedback = function AIFeedback(_ref) {
	var onFeedbackSubmit = _ref.onFeedbackSubmit,
	    hideUI = _ref.hideUI,
	    _ref$overrideState = _ref.overrideState,
	    overrideState = _ref$overrideState === undefined ? {} : _ref$overrideState;

	var _useState = (0, _react.useState)(false),
	    showInput = _useState[0],
	    setShowInput = _useState[1];

	var _useState2 = (0, _react.useState)(null),
	    feedbackType = _useState2[0],
	    setFeedbackType = _useState2[1];

	var _useState3 = (0, _react.useState)(''),
	    feedbackText = _useState3[0],
	    setFeedbackText = _useState3[1];

	var _useState4 = (0, _react.useState)(false),
	    feedbackRecorded = _useState4[0],
	    setFeedbackRecorded = _useState4[1];

	var handleButtonClick = function handleButtonClick(type) {
		if (feedbackType === type) {
			setFeedbackType(null);
			setShowInput(false);
		} else {
			setFeedbackType(type);
			setShowInput(true);
		}
	};

	var handleInputChange = function handleInputChange(e) {
		setFeedbackText(e.target.value);
	};

	var handleSubmit = function handleSubmit() {
		onFeedbackSubmit(feedbackType === 'positive', feedbackText);

		// setFeedbackType(null);
		setFeedbackText('');
		setShowInput(false);
		setFeedbackRecorded(true);
	};
	var handleCancel = function handleCancel() {
		setFeedbackType(null);
		setFeedbackText('');
		setShowInput(false);
	};

	(0, _react.useEffect)(function () {
		if (overrideState && overrideState.isRecorded) {
			setFeedbackRecorded(true);
			setFeedbackType(overrideState.feedbackType || 'positive');
		}
	}, [overrideState]);

	if (hideUI) {
		return null;
	}
	if (feedbackRecorded) {
		return _react2.default.createElement(
			_AIAnswer.AIFeedbackContainer,
			null,
			_react2.default.createElement(
				'div',
				{ className: '--feedback-svgs-wrapper' },
				feedbackType === 'positive' ? _react2.default.createElement(_ThumbsUpSvg2.default, { className: 'selected' }) : _react2.default.createElement(_ThumbsDownSvg2.default, { className: 'selected' })
			)
		);
	}
	return _react2.default.createElement(
		_AIAnswer.AIFeedbackContainer,
		null,
		!showInput && _react2.default.createElement(
			'div',
			{ className: '--feedback-svgs-wrapper' },
			_react2.default.createElement(_ThumbsUpSvg2.default, {
				className: feedbackType === 'positive' ? 'selected' : '',
				onClick: function onClick() {
					return handleButtonClick('positive');
				}
			}),
			_react2.default.createElement(_ThumbsDownSvg2.default, {
				className: feedbackType === 'negative' ? 'selected' : '',
				onClick: function onClick() {
					return handleButtonClick('negative');
				}
			})
		),
		showInput && _react2.default.createElement(
			'div',
			{ className: '--feedback-input-wrapper' },
			_react2.default.createElement(_Input2.default, {
				show: showInput,
				placeholder: feedbackType === 'positive' ? 'What do you like about the response?' : 'What was the issue with the response? How can it be improved?',
				value: feedbackText,
				onChange: handleInputChange
			}),
			_react2.default.createElement(
				_Button2.default,
				{ primary: true, onClick: handleSubmit },
				'Submit'
			),
			_react2.default.createElement(
				_Button2.default,
				{ onClick: handleCancel },
				'Cancel'
			)
		)
	);
};

AIFeedback.propTypes = {
	onFeedbackSubmit: _propTypes.func,
	hideUI: _propTypes.bool,
	// eslint-disable-next-line react/forbid-prop-types
	overrideState: _propTypes.object
};

exports.default = _react2.default.memo(AIFeedback);